var map = {
	"./Placeholder.png": 8336,
	"./auto.png": 362,
	"./component.png": 6290,
	"./cover.png": 2974,
	"./create.png": 9283,
	"./design-token.png": 5533,
	"./document.png": 7444,
	"./guidance.png": 9261,
	"./handoff.png": 2173,
	"./hero.png": 5535,
	"./image-container.png": 1898,
	"./improvement.png": 8827,
	"./interaction.png": 2967,
	"./logo-wyndham-destinations.svg": 3775,
	"./naming.png": 979,
	"./organization.png": 3058,
	"./plan.png": 6,
	"./plugin.png": 8726,
	"./restructure.png": 3489,
	"./styles.png": 7305,
	"./template.png": 305,
	"./token-1.png": 8494,
	"./token-2.png": 5845
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2496;